import { UILogic } from "@aptus/frontend-core";
import { useRoutes } from "domains";
import { Food } from "hooks/foods/models/food";
import { SaveFoodInput } from "hooks/foods/models/foodInput";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { UseFormTypes } from "../useFormTypes";

interface Props {
	initialValues?: Food;
	submit: (values: SaveFoodInput) => void;
	remove: (id: string) => void;
}

interface Result extends UseFormTypes<Food> {
	handleDelete: (id: string) => void;
}

export const useFoodPairingForm: UILogic<Props, Result> = ({ initialValues, remove, submit }) => {
	const { currentQueryString: { selected, create }, updateQueryString } = useRoutes();

	const defaultValues = {
		...initialValues,
		id: selected,
	};

	const { register, handleSubmit, control, reset, formState: { errors } } = useForm<Food>({ defaultValues });

	useEffect(() => {
		reset(defaultValues);
	}, [create, initialValues]);

	const handleFormSubmit = (values: Food): void => {
		submit(values);
	};

	const handleDelete = (id: string) => {
		remove(id);
		updateQueryString({ selected: null, create: true });
	};

	return {
		register,
		control,
		handleFormSubmit: handleSubmit(handleFormSubmit),
		errors,
		handleDelete,
	};
};
